// icons.ts
import { FileText, Home, User, Settings, Search, Handshake, BookUser, CircleHelp, ChevronLeft, CircleAlert, Plus, X, ArrowLeft, ChevronRight, Pencil, Trash2, FileUser, Check, Calendar, Mail, Navigation, Minus, Eye, Fullscreen, CornerDownRight, ArrowUpDown, LayoutDashboard, ClipboardList, NotepadText, ShieldAlert, Target, ClipboardCheck, CirclePlus, History, CircleCheckBig, FileCheck, Users, SearchCheck, Send, Download, ClipboardCopy, Menu, MapPin, Truck, Bus, Cpu, LogOut, Fingerprint, DoorOpen, Radio, BarChart3, Gauge, Activity } from 'lucide-angular';

export const Icons = {
    FileText,
    Home,
    User,
    Settings,
    Search,
    Handshake,
    BookUser,
    CircleHelp,
    ChevronLeft,
    ChevronRight,
    CircleAlert,
    CirclePlus,
    Plus,
    X,
    ArrowLeft,
    Pencil,
    Trash2,
    FileUser,
    Check,
    Calendar,
    Mail,
    Navigation,
    Minus,
    Eye,
    Fullscreen,
    CornerDownRight,
    ArrowUpDown,
    LayoutDashboard,
    ClipboardList,
    NotepadText,
    ShieldAlert,
    Target,
    ClipboardCheck,
    History,
    CircleCheckBig,
    FileCheck,
    Users,
    SearchCheck,
    Send,
    Download,
    ClipboardCopy,
    Menu,
    MapPin,
    Truck,
    Bus,
    Cpu,
    LogOut,
    Fingerprint,
    DoorOpen,
    Radio,
    BarChart3,
    Gauge,
    Activity
} as const;
